module.exports = __webpack_public_path__ + "img/study.cf963641.png";